module.exports = __webpack_public_path__ + "media/Dialogo com as expressoes cotidianas.fad4ef20.mp3";